import React from 'react';

import InputField from './InputField';
import {
    validatePhone,
    validatePhoneIncludingSwedishLandline
} from '../validations/validations';

type PropsType = {
    name: string,
    label: string,
    value: string,
    required?: boolean,
    helperText?: string,
    sx?: {[key: string]: string | number },
    variant?: 'filled' | 'outlined' | 'standard',
    landlineAllowed?: boolean,
    onChange: (a: any) => void
};

export default function TextField(props: PropsType) {
    const {
        value,
        landlineAllowed = false
    } = props;

    const validations = landlineAllowed
        ? [validatePhoneIncludingSwedishLandline({ value })]
        : [validatePhone({ value })];

    return (
        <InputField
            {...props}
            validations={validations}
        />
    );
}
